<template>
    <div class="all bg-white big-iframe">
        <!--<vue-scroll :ops="ops" style="width:100%;height:420px">-->
            <div class="search-warp clearfix newPlan">
                <button class="search-btn fr"><i class="icons search-icon"></i></button> 
                <div class="hidden"><input class="input-text" v-model="searchQuery" type="text" placeholder="请输入方案名称进行搜索"/></div>
            </div>
            <div class="plan-list mt20">
                <div class="item" v-for="(item,index) in planShowList" :key="index">
                    <p><strong>{{item.typeName}}</strong></p>
                    <ul class="plan-ul clearfix">
                        <li v-for="(items,index) in item.schemeList" :key="index" :class="items.id == $parent.isPlan.id ? 'curr' : ''" @click="enterPlan(items.id,items.name);">
                            <div class="caozu fr">
                                <a class="icons edit-icon1" href="javascript:void(0);" @click.stop="editPlan(items.id);"></a>
                                <a class="icons del-sm-icon" href="javascript:void(0);" @click.stop="delPlan(items.id);"></a>
                            </div>
                            <span class="name ovhidden">{{items.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        <!--</vue-scroll>-->
        <!-- 删除提示 -->
        <Dialog ref="delPlanModal" :callback="enterDelPlan" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否删除此方案</p>
            </div>
        </Dialog>
    </div>
</template>
<script>
import Dialog from '@/components/dialog';
export default {
    components:{Dialog},
    data() {
        return {
            current:'',
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            searchQuery:'',//方案关键词搜索
            planShowList:[],//方案显示列表
        }
    },
    mounted() {
		let that = this;
        that.current = JSON.parse(window.sessionStorage.planStorage);
        console.log(that.current)
        that.$nextTick(()=> {
            that.getPlanList()
        });
    },
    created() {
		
    },
    watch: {
      searchQuery (val) {
          this.searchPlan(val);    
      },
    },
    methods: {
        // 获取方案列表
        getPlanList (type) {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据');
            that.$api.get('monitor/scheme/list',null,r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.planList = r.data;
                    that.searchPlan(that.searchQuery);
                    if(!type){
                        that.$refs.planModal.showMaskFun();
                    }
                });           
            })
        },
        // 选择方案
        selectPlan () {
            let that = this;
            that.getPlanList();
        },
        // 确定方案
        enterPlan (id,name,from) {
            let that = this;
            let value = {
                id:id, 
                name:name
            };
            that.$api.get('monitor/scheme/change',{id:id},r =>{
                that.$utils.returnCode(r,function(){
                    that.planList = r.data; 
                    that.resetSetItem('planStorage', JSON.stringify(value));
                    if(from){
                        that.$parent.getCurrplan();
                        that.$router.push({ path:'/analysis/yuYingGather'})
                    }else{
                        window.location.reload();
                    }
                });           
            })
        },
        // 删除方案
        delPlan (id) {
            let that = this;
            that.delId = id;
            that.$refs.delPlanModal.showMaskFun();
        },
        // 确认删除
        enterDelPlan () {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/scheme/delete',{id:that.delId},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('删除成功');
                    if(that.$parent.isPlan.id == that.delId){//删除的方案是当前方案会刷新页面
                        location.reload();
                        return;
                    }
                    if(r.data.length === 0){//方案全部删除完
                        that.$parent.getCurrplan();
                        that.$refs.planModal.closeMask();
                        return;
                    }
                    that.planList = r.data;
                    that.searchPlan(that.searchQuery);
                    that.$refs.delPlanModal.closeMask();
                    that.$refs.planModal.showMaskFun();
                });           
            })
        },
        // 修改方案
        editPlan (id) {
            // this.$refs.planModal.closeMask();
            this.$router.push({ path:'/analysis/buildSolution',query:{planId:id}})
        },
        // 搜索方案
        searchPlan (val) {
            let that = this;
            if(val == ''){
                that.planShowList = that.planList;
            }else{
                let planList = that.planList;
                let schemeList = [];
                for(let i of planList){
                    let num = 0;
                    let arr1 = [];
                    for(let j of i.schemeList){
                        num++;
                        let name = j.name;
                        if(name.indexOf(val) != -1){
                            if(num === 1){
                                
                            }
                            arr1.push(j)
                        }
                        
                    }
                    if(arr1 != ''){
                        schemeList.push({
                            'typeName':i.typeName,
                            'schemeList':arr1
                        })
                    }
                }
                that.planShowList = schemeList;
            }
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/index/plan.vue